<div class="zone-slider" [ngStyle]="hostVars" [class.is-disabled]="disabled">
  <div class="zone-slider__label" *ngIf="config.label">{{ config.label }}<span class="dvm-mandatory-mark" *ngIf="isMandatory" aria-hidden="true">*</span></div>

  <div class="zone-slider__header" *ngIf="showValue || (showBadge && model.badgeText)">
    <div class="zone-slider__pill" *ngIf="showValue">
      <span class="zone-slider__value">{{ model.valueText }}</span>
      <span class="zone-slider__sub" *ngIf="model.subLabelText">{{ model.subLabelText }}</span>
    </div>
    <div class="zone-slider__badge" *ngIf="showBadge && model.badgeText" [title]="model.badgeText">{{ model.badgeText }}</div>
  </div>

  <div class="zone-slider__track-wrap">
    <div class="zone-slider__track" aria-hidden="true">
      <span
        class="zone-slider__zone"
        *ngFor="let zone of model.zones; trackBy: trackZone"
        [class.is-active]="zone.active"
        [style.left.%]="zone.leftPct"
        [style.width.%]="zone.widthPct"
        [style.background]="zone.color"
        [title]="zone.label"
      ></span>
      <!-- A div, not a span: the zones' `:last-of-type` must stay the last ZONE. -->
      <div class="zone-slider__thumb" [style.left.%]="model.thumbPct"></div>
    </div>

    <!-- The real control: transparent, sized so its thumb centre travels the
         whole track, which keeps the drawn thumb exactly under the pointer. -->
    <input
      class="zone-slider__input"
      type="range"
      [id]="inputId"
      [min]="model.min"
      [max]="model.max"
      [step]="model.step"
      [value]="model.value"
      [disabled]="disabled"
      [attr.aria-label]="config.label || config.title || 'Value'"
      [attr.aria-valuetext]="model.valueText + (model.badgeText ? ', ' + model.badgeText : '')"
      (input)="onInput($event)"
      (change)="onCommit()"
    />
  </div>

  <!-- Every boundary's value (min, each level, max) under its spot on the track. -->
  <div class="zone-slider__boundaries" *ngIf="showBoundaryValues; else rangeLabels">
    <span
      class="zone-slider__boundary"
      *ngFor="let point of model.boundaries; let first = first; let last = last"
      [class.is-first]="first"
      [class.is-last]="last"
      [style.left.%]="point.pct"
    >{{ point.text }}</span>
  </div>
  <ng-template #rangeLabels>
    <div class="zone-slider__range" *ngIf="showRangeLabels">
      <span>{{ model.minText }}</span>
      <span>{{ model.maxText }}</span>
    </div>
  </ng-template>
</div>
